import headers from './components/headers.vue'
import footers from './components/footers.vue'
import hero from './components/hero.vue'
import breadcrumb from './components/breadcrumb.vue'
import swiper from './components/swiper.vue'
import reservation from './components/reservation.vue'
import carousel from './components/carousel.vue'
import plan from './components/plan.vue'
import slice from './components/slice.vue'
import localnav from './components/localnav.vue'
import la from './components/la.vue'
import gallery from './components/gallery.vue'
import { createApp } from 'vue'

export default function partials(){
  return new Promise((resolve) => {
    const app = createApp({
      components: {
        headers: headers,
        footers: footers,
        hero: hero,
        breadcrumb: breadcrumb,
        swiper: swiper,
        reservation: reservation,
        carousel: carousel,
        plan: plan,
        slice: slice,
        localnav: localnav,
        la: la,
        gallery: gallery,
      }
    });
    
    // Vue.jsを#appにマウント
    app.mount('#app');
    resolve();
  });
}
